import React from 'react';
export function BlueprintGrid() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-21">
      <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-22">
        <defs data-id="element-23">
          <pattern id="blueprint-grid" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse" data-id="element-24">
            {/* Major grid lines */}
            <path d="M 80 0 L 0 0 0 80" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-25" />
            {/* Minor grid lines */}
            <path d="M 40 0 L 40 80 M 0 40 L 80 40" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.5" data-id="element-26" />
          </pattern>
          <linearGradient id="blueprint-fade" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-27">
            <stop offset="0%" stopColor="white" stopOpacity="0.2" data-id="element-28" />
            <stop offset="15%" stopColor="white" stopOpacity="1" data-id="element-29" />
            <stop offset="85%" stopColor="white" stopOpacity="1" data-id="element-30" />
            <stop offset="100%" stopColor="white" stopOpacity="0.2" data-id="element-31" />
          </linearGradient>
          <mask id="blueprint-mask" data-id="element-32">
            <rect width="100%" height="100%" fill="url(#blueprint-fade)" data-id="element-33" />
          </mask>
        </defs>
        <rect width="100%" height="100%" fill="url(#blueprint-grid)" mask="url(#blueprint-mask)" data-id="element-34" />
      </svg>
    </div>;
}